import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["stateRequest"];
  }

  static get values() {
    return { store: Object };
  }

  // Public Methods

  register({ detail: { id, values } }) {
    if (this.storeValue[id] !== undefined) {
      this._updateChild(id);
      return;
    }

    this._updateStoreValue(id, values);
  }

  sync({ detail: { id, values } }) {
    if (this.storeValue[id] === undefined) return;

    this._updateStoreValue(id, values);
  }

  manualSync({ params: { id, values } }) {
    if (this.storeValue[id] === undefined) return;

    this._updateStoreValue(id, values);
  }

  clear() {
    this.storeValue = {}; // Clears *whole* store
  }

  distributeState() {
    if (this.storeValue === undefined) return;

    for (const key in this.storeValue) {
      this._updateChild(key);
    }
  }

  stateRequestTargetConnected() {
    this.distributeState();
  }

  // Private Methods

  _updateStoreValue(id, values) {
    this.storeValue = { ...this.storeValue, [id]: values };
  }

  _updateChild(id) {
    this.dispatch(
      "update",
      { detail: { id: id, values: this.storeValue[id] }, prefix: "store" }
    );
  }
}
